// Schemas API service
// Fetches reusable event schemas and attaches them to a test flow.
import axios from './authService';
import { API_ENDPOINTS } from '../config/apiConfig';

/**
 * Fetch reusable schemas, optionally narrowed by the filter set. Array filters
 * (`priorities`, `eventTypes`) are serialized as repeated query keys; the two
 * `search*` fields as substrings. Empty filters are omitted. Returns the raw
 * `data` array from the response (empty array if absent).
 */
export const fetchSchemas = async ({ filters = {}, limit = 25, offset = 0 } = {}) => {
  const { priorities = [], eventTypes = [], searchEventName = '', searchEventTitle = '' } = filters;

  const params = new URLSearchParams();
  priorities.forEach((p) => params.append('priorities', p));
  eventTypes.forEach((t) => params.append('event_type', t));
  if (searchEventName) params.set('searchEventName', searchEventName);
  if (searchEventTitle) params.set('searchEventTitle', searchEventTitle);
  params.set('limit', String(limit));
  params.set('offset', String(offset));

  const response = await axios.get(`${API_ENDPOINTS.SCHEMAS}?${params.toString()}`);
  return response.data?.data || [];
};

/**
 * Attach a schema to a test flow at the given sequence. The backend builds the
 * event (with its Inbound + Outbound/Mixpanel scenarios) from the schema values.
 */
export const addSchemaToFlow = async ({ schema_id, test_flow_id, sequence }) => {
  const response = await axios.post(API_ENDPOINTS.CREATE_EVENT_FROM_SCHEMA, {
    schema_id,
    test_flow_id,
    sequence,
  });
  return response.data;
};
